import { USER_ROLES, type UserRole } from '@cult/domain';
import clsx from 'clsx';
import styles from './RoleChip.module.scss';

type Props = {
  variant: UserRole;
  label?: string;
  style?: React.CSSProperties;
};

export const ROLE_LABELS: Record<UserRole, string> = {
  [USER_ROLES.SUPER_ADMIN]: 'Super Admin',
  [USER_ROLES.ADMIN]: 'Admin',
  [USER_ROLES.MODERATOR]: 'Moderator',
  [USER_ROLES.IDEA_MANAGER]: 'Idea Manager',
  [USER_ROLES.MEMBER]: 'Member',
};

export const RoleChip = ({ variant, label, style }: Props) => (
  <span className={clsx(styles.chip, styles[variant])} style={style}>
    {label ?? ROLE_LABELS[variant]}
  </span>
);
